import { Injectable } from '@angular/core';
import { EventType } from '../../models/_enum-collections';

@Injectable({
  providedIn: 'root'
})
export class ProgramSharedService {
  milestone2ExpirationDate!: string;
  eventTypeId!: number;
  selectedReviewPoeDocumentId: number | null = null;

  setMilestone2ExpirationDate(data: string): void {
    this.milestone2ExpirationDate = data;
  }

  getMilestone2ExpirationDate(): string {
    return this.milestone2ExpirationDate;
  }

  setEventType(data: number): void {
    this.eventTypeId = data;
  }

  getEventType(): number {
    return this.eventTypeId;
  }

  checkEventType(eventType: EventType) {
    return this.eventTypeId !== undefined && this.eventTypeId == eventType;
  }

  setReviewPoeDocumentId(data: number): void {
    this.selectedReviewPoeDocumentId = data;
  }

  getReviewPoeDocumentId(): number | null {
    return this.selectedReviewPoeDocumentId;
  }
}
